import { render, staticRenderFns } from "./Monitoramento.vue?vue&type=template&id=882ecdc6&scoped=true&lang=pug"
import script from "./Monitoramento.vue?vue&type=script&lang=js"
export * from "./Monitoramento.vue?vue&type=script&lang=js"
import style0 from "./Monitoramento.vue?vue&type=style&index=0&id=882ecdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882ecdc6",
  null
  
)

export default component.exports